import React, { useState, useEffect } from "react";
import { Routes, Route, Navigate, useLocation } from "react-router-dom";
import SearchOrganization from "../views/searchview/SearchOrganization";
import Redirect from "../views/Redirect";
import EmployeeSearch from "../views/searchview/EmployeeSearch";
import Footer from "../components/Footer";
import Header from "../components/Header";
import { useSelector } from "react-redux";
import EmployeeClaimLeave from "../views/claimleaveview/EmployeeClaimLeave";
import ReportTypeSelection from "../views/reports/ReportTypeSelection";
import ReportSelection from "../views/reports/ReportSelection";
import Report from "../views/reports/Report";
import Dashboard from "../views/dashboard/Dashboard";
import Preferences from "../views/preferences/Preferences";
import Login from "../Login";
import Help from "../views/help/Help";
import FrequentlyAskedQuestions from "../views/help/frequently_asked_questions/FrequentlyAskedQuestions";
import ReferenceResources from "../views/help/reference_resources/ReferenceResources";
import LandingPage from "../components/LandingPage";
import ViewSectionPage from "../views/reports/ViewSectionPage";
import ReportViewPage from "../views/reports/ReportViewPage";
import { EventProvider } from "../EventContext";
import ManageMyView from "../views/reports/ManageMyView";

function AppRoutes() {
    const { user } = useSelector((state) => state.auth);
    const { totalParentOrganizations } = useSelector(
        (state) => state.organizations
    );

    // to find previews page URL
    const useFindPath = () => {
        const location = useLocation();
        const [currentPath, setCurrentPath] = useState([]);
        useEffect(() => {
            setCurrentPath([...currentPath, window.location.pathname]);
        }, [location]);

        return currentPath;
    };

    const previousUrl = useFindPath();

    //Increase iFrame width on report screen
    const matchUrl = /reports\/[a-z]+\/[a-z]+\/\d/gm;
    const url = window.location.pathname;

    let urlDisplay = url.match(matchUrl);

    const className = urlDisplay === null ? "container " : "";

    const [showInformationBanner, setShowInformationBanner] = useState(true);

    const hideInformationBanner = () => {
        setShowInformationBanner(false);
    };

    const [isPreferenceSaved, setIsPreferenceSaved] = useState(false);

    const handleSavedPreference = () => {
        setIsPreferenceSaved(false);
    };

    return (
        <div id="container_main">
            <EventProvider>
                <Header
                    showInformationBanner={showInformationBanner}
                    hideInformationBanner={hideInformationBanner}
                    isPreferenceSaved={isPreferenceSaved}
                    handleSavedPreference={handleSavedPreference}
                />

                <main
                    style={{ paddingBottom: urlDisplay === null ? "" : "0px" }}
                >
                    <div className={"container-content " + className}>
                        <div className="row">
                            <div className="col-md-12" style={{ padding: 0 }}>
                                <Routes>
                                    <Route
                                        path="/"
                                        element={
                                            <Redirect
                                                previousUrl={previousUrl}
                                            />
                                        }
                                    />
                                    <Route path="/login" element={<Login />} />

                                    {user && (
                                        <>
                                            <Route
                                                path="/organization/:orgId/employees/:id"
                                                element={
                                                    <EmployeeClaimLeave
                                                        previousUrl={
                                                            previousUrl
                                                        }
                                                        showInformationBanner={
                                                            showInformationBanner
                                                        }
                                                    />
                                                }
                                            />

                                            <Route
                                                path="/home"
                                                element={<LandingPage />}
                                            />

                                            <Route
                                                path="/organization/:id/employees/search"
                                                element={
                                                    <EmployeeSearch
                                                        previousUrl={
                                                            previousUrl
                                                        }
                                                    />
                                                }
                                            />

                                            <Route
                                                path="/help"
                                                element={<Help />}
                                            />
                                            <Route
                                                path="/help/faq"
                                                element={
                                                    <FrequentlyAskedQuestions />
                                                }
                                            />
                                            <Route
                                                path="/help/referenceresources"
                                                element={<ReferenceResources />}
                                            />

                                            <Route
                                                path="/reports"
                                                element={
                                                    <ReportTypeSelection />
                                                }
                                            />
                                            <Route
                                                path="/reportingcapabilities"
                                                element={
                                                    <ViewSectionPage
                                                        previousUrl={
                                                            previousUrl
                                                        }
                                                    />
                                                }
                                            />
                                            <Route
                                                path="/reportingcapabilities/:viewtype"
                                                element={
                                                    <ReportViewPage
                                                        previousUrl={
                                                            previousUrl
                                                        }
                                                    />
                                                }
                                            />

                                            <>
                                                {" "}
                                                <Route
                                                    path="/reports/:type"
                                                    element={
                                                        <ReportSelection />
                                                    }
                                                />
                                                <Route
                                                    path="/reports/:type/:group/:reportId"
                                                    element={<Report />}
                                                />
                                            </>

                                            <Route
                                                path="/dashboard"
                                                element={<Dashboard />}
                                            />
                                            <Route
                                                path="/reportingcapabilities/manageviews"
                                                element={<ManageMyView />}
                                            />
                                            <Route
                                                path="/preferences"
                                                element={
                                                    <Preferences
                                                        setIsPreferenceSaved={
                                                            setIsPreferenceSaved
                                                        }
                                                    />
                                                }
                                            />

                                            {totalParentOrganizations > 1 && (
                                                <Route
                                                    path="/search"
                                                    element={
                                                        <SearchOrganization
                                                            previousUrl={
                                                                previousUrl
                                                            }
                                                        />
                                                    }
                                                />
                                            )}
                                        </>
                                    )}

                                    <Route
                                        path="*"
                                        element={<Navigate replace to="/" />}
                                    />
                                </Routes>
                            </div>
                        </div>
                    </div>
                </main>

                <Footer />
            </EventProvider>
        </div>
    );
}

export default AppRoutes;
